import pkg from "../package.json";
import VocLogger from "./VocLogger.js";
import ModuleLoader from "./ModuleLoader.js";
import ScriptLoader from "./ScriptLoader.js";
import "./nibara";
import getFeatures from "./feature.js";

Voonto.ready.then((app) => {

  const
    vocLogger = new VocLogger(app),
    moduleLoader = new ModuleLoader(app),
    scriptLoader = new ScriptLoader(app),
    Nibara = window.nibara
  ;
  //Nibara.nTools.addNibaraMethod('VERSION',pkg.version);
  Nibara.VERSION = pkg.version;
  Nibara.feature = getFeatures();

  vocLogger.initialize();
  app.when('nibara:logger').then(function (Logger) {
      Logger.debug('[Logger] nibara version: ' + pkg.version);
      Nibara.logger = Logger;
      moduleLoader.initialize();
      scriptLoader.initialize();

      Logger.debug('[Logger] Fin initialize ModuleLoader y ScriptLoader');

      Nibara.moduleLoaderUpdate = ($elm) => {
          if($elm instanceof jQuery) {
              moduleLoader.initialize($elm);
          } else {
              Logger.warn('[Logger] Can not initialize moduleLoader. Element is not instance of jQuery.');
          }
      };
  });

  /*vocLogger.initialize().then(() => {
    Logger.debug('nibara version: ' + pkg.version);

    moduleLoader.initialize();
    scriptLoader.initialize();

    Nibara.moduleLoaderUpdate = ($elm) => {
      if($elm instanceof jQuery) {
        moduleLoader.initialize($elm);
      } else {
        Logger.warn('Can not initialize moduleLoader. Element is not instance of jQuery.');
      }
    };
  }).catch((e) => {
    Logger.error('Main exception:' + e.message);
  });*/
});



// WEBPACK FOOTER //
// ./src/index.js